const menuInitialState = {
    show:false
};

export default (state = menuInitialState , action) => {
    switch(action.type){
        case "OPEN_MENU":
            return{
               ...state,
               show:action.show
            }
        case "CLOSE_MENU":
            return{
                ...state,
                show:action.show
            }
        default :
            return state;
    }

}